import InvoicesForPaymentDatagrid from 'src/components/EntityDatagrids/InvoicesForPaymentDatagrid';

const InvoicesPaymentPage = () => (<InvoicesForPaymentDatagrid />);
export default InvoicesPaymentPage;
